import { useAuth } from '@clerk/react';
import { type ReactElement } from 'react';
import { useEnsureActiveOrg } from '../hooks/useEnsureActiveOrg';

// Thin wrapper that mounts `useEnsureActiveOrg` only after Clerk reports the
// user as signed in. Splitting the auth check from the hook itself avoids
// calling `useOrganizationList` on signed-out sessions (Clerk logs a warning).
//
// See `src/hooks/useEnsureActiveOrg.ts` for why this can't be inlined.
function ActivateInner(): null {
  useEnsureActiveOrg();
  return null;
}

export default function AutoActivateSingleOrg(): ReactElement | null {
  const { isSignedIn } = useAuth();
  if (!isSignedIn) return null;
  return <ActivateInner />;
}
